<template>
    <div>
        ABSTRACT REPORT WATER
    </div>
</template>